import React, { useEffect } from 'react';
import 'iconify-icon';
import { testimonialsData } from '../data/mock';

const Testimonials = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" className="relative py-24 border-t border-neutral-900" style={{ background: 'rgba(10, 10, 10, 0.72)' }}>
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-accent-orange mb-4 block animate-on-scroll">
            Cases de Sucesso
          </span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 animate-on-scroll delay-100 text-[#EAEAEA]">
            Depoimentos
          </h2>
          <p className="text-lg text-neutral-400 max-w-2xl mx-auto animate-on-scroll delay-200">
            O que nossos clientes reportam após a intervenção
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              className="group relative glow-card bg-[#1A1A1A] p-6 rounded-xl hover-lift cursor-pointer animate-on-scroll overflow-hidden"
              style={{ transitionDelay: `${index * 0.1}s` }}
              onClick={() => testimonial.video && window.open(testimonial.video, '_blank')}
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                e.currentTarget.style.setProperty('--x', `${x}px`);
                e.currentTarget.style.setProperty('--y', `${y}px`);
              }}
            >
              {/* Image with persistent play overlay */}
              <div className="relative mb-4 rounded-lg overflow-hidden aspect-square bg-neutral-900">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Subtle dark gradient — always visible */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                {/* Play button — visible at low opacity, full on hover */}
                {testimonial.video && (
                  <div className="absolute inset-0 flex items-center justify-center transition-all duration-300">
                    <div className="w-14 h-14 rounded-full bg-accent-orange/90 flex items-center justify-center shadow-lg shadow-accent-orange/40 scale-90 opacity-70 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 ring-2 ring-white/20">
                      <iconify-icon icon="solar:play-bold" className="text-2xl text-white"></iconify-icon>
                    </div>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="relative z-10 mb-3">
                <h3 className="text-lg font-semibold mb-1 text-[#EAEAEA]">{testimonial.name}</h3>
                <p className="text-sm text-neutral-500">
                  {testimonial.company}
                  {testimonial.role && ` • ${testimonial.role}`}
                </p>
              </div>

              <p className="relative z-10 text-sm text-neutral-400 leading-[1.7] mb-4">
                &ldquo;{testimonial.text}&rdquo;
              </p>

              <div className="relative z-10 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-accent-orange group-hover:translate-x-1 transition-transform">
                Assistir
                <iconify-icon icon="solar:arrow-right-linear"></iconify-icon>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;